import {  get, post } from '../utils/axios'

export const getTransferAPI = async (uuid) => {
  return await get('transfer/detail/profile',uuid)
}

export const getTransferNewAPI = async (body) => {
  return await get('transfer/employee',body)
}

export const createTransferAPI = async (body) => {
  return await post('transfer/promote', body)
}

export const getTransferHistoryAPI = async (param) => {
  return await get('transfer', param)
}

export const getTransferDetailAPI = async (transferNo) => {
  return await get('transfer/detail', transferNo)
}

export const createTransferOrgAPI = async (body) => {
  return await post('transfer/org', body)
}